import { useLocation } from 'react-router-dom';
import { Stack, Text } from '@repletoryreach/sdk-ui';
import { Alert } from '@repletoryreach/sdk-ui/data-display';
import { LoginForm } from './components/LoginForm';
import { AuthCardHeader } from '../components/AuthCardHeader';
import { TENANT_CONSOLE_URL } from '../../../app/external-links';
import { useT } from '../../../i18n/I18nProvider';

export default function LoginPage() {
  const t = useT();
  const location = useLocation();
  // `RequirePlatformAdmin` sends a tenant-scoped session here with this flag.
  // It can only ever land on sign-in, so the notice lives with the screen that
  // receives it rather than with the layout around it.
  const wrongDomain = Boolean((location.state as { wrongDomain?: boolean } | null)?.wrongDomain);

  return (
    <Stack gap="md">
      <AuthCardHeader title={t('auth.login.title')} subtitle={t('auth.staffOnly')} />
      {wrongDomain && (
        <Alert color="error" title={t('auth.layout.wrongDomainTitle')}>
          <Stack gap="xs" align="flex-start">
            <Text fz="sm">{t('auth.layout.wrongDomainBody')}</Text>
            {TENANT_CONSOLE_URL !== '' && (
              <a href={TENANT_CONSOLE_URL} style={{ color: 'var(--rr-color-primary)', fontSize: 13 }}>
                {t('auth.layout.wrongDomainLink')}
              </a>
            )}
          </Stack>
        </Alert>
      )}
      {/* The forgot-password link used to hang under the form on its own line.
          It belongs beside the remember-me control, where the eye already is
          after reading the password field, so the form owns it now. */}
      <LoginForm />
    </Stack>
  );
}
